module.exports = __webpack_public_path__ + "img/read.b4cdb895.jpeg";